import React from 'react';
import { Box, Typography } from '@mui/material';
import { TRICOLOR } from './components/PageSection';

// Shared helpers for the news archive. Articles live as static JSON under
// public/data/news/ (one file per article + index.json) so a future admin
// panel can manage them without touching the app bundle:
//   index.json           → [{ slug, title, date, categories, image, excerpt }]
//   <slug>.json          → { slug, title, date, categories, image, excerpt, html }
// Images live in public/assets/images/news/ and are referenced by path.

let indexCache = null;

export async function fetchNewsIndex() {
  if (indexCache) return indexCache;
  const res = await fetch('/data/news/index.json');
  if (!res.ok) throw new Error('news index unavailable');
  indexCache = await res.json();
  return indexCache;
}

export async function fetchNewsArticle(slug) {
  if (!/^[a-z0-9-]+$/.test(slug)) throw new Error('bad slug');
  const res = await fetch(`/data/news/${slug}.json`);
  if (!res.ok) throw new Error('article unavailable');
  return res.json();
}

export function formatNewsDate(iso) {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
}

// Category chip — crimson is reserved for Sicurezza, everything else green.
export function CategoryChip({ label }) {
  const red = /sicurezza/i.test(label);
  return (
    <Typography
      sx={{
        fontFamily: '"Sora", sans-serif',
        fontSize: '11.5px',
        fontWeight: 700,
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: red ? '#c10a27' : '#6d8511',
        backgroundColor: red ? 'rgba(193,10,39,0.08)' : 'rgba(134,163,21,0.12)',
        borderRadius: '999px',
        px: '10px',
        py: '3px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  );
}

// 16:9 thumbnail with tricolor-bar fallback when an article has no image.
export function NewsThumb({ image, title, ratio = '52%' }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: ratio,
        backgroundColor: '#e9f1f6',
        overflow: 'hidden',
        '&:after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: '3px',
          backgroundImage: TRICOLOR,
        },
      }}
    >
      {image && (
        <Box
          component="img"
          src={image}
          alt={title}
          loading="lazy"
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
    </Box>
  );
}
